import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  width: 242px;
  height: 48px;

  background-color: #ffffff;
  color: #0c3bdd;
  font-weight: bold;
  font-size: 14px;

  border: 0;
  border-radius: 6px;
  opacity: 1;
  cursor: pointer;

  transition: background-color 0.2s;
`;
